import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { Subscription } from 'rxjs';
import { MetricsAnalysis } from 'src/app/models/analysis/metrics-analysis.model';
import { ClustersService } from 'src/app/services/clusters.service';
import { Cluster } from 'src/app/models/cluster.model';

@Component({
  selector: 'app-risk-management-metrics',
  templateUrl: './risk-management-metrics.component.html',
  styleUrls: ['./risk-management-metrics.component.scss']
})
export class RiskManagementMetricsComponent implements OnInit, OnDestroy {

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;

  investableMA: MetricsAnalysis;
  currentInvestableSubscription: Subscription;

  metricsPivot: string = ['yearly','one_year','three_years'][2];
  maxNbColumns: any = {
    yearly: 5,
    one_year: 5,
    three_years: 5
  }

  constructor(private clustersService: ClustersService) { }

  ngOnInit(): void {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (currentCluster: Cluster) => {
        this.currentCluster = currentCluster;
      }
    );
    this.clustersService.emitCurrentCluster();

    this.subscribeToCurrentInvestable();
  }

  ngOnDestroy() {
    if(this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        if (investable_portfolio) {
          this.investableMA = investable_portfolio.metricsAnalysis;
        }
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  getFormattedPeriods(slice?: boolean, pivot?: string): string[] {
    if (slice==undefined) {slice = true;}
    if (pivot==undefined) {pivot = this.metricsPivot;}
    if (this.investableMA) {
      let last_periods;
      if (slice) {
        last_periods = this.investableMA[pivot].periods.slice(-this.maxNbColumns[this.metricsPivot]);
      } else {
        last_periods = this.investableMA[pivot].periods;
      }
      return last_periods.map(
        (period) => {
          const date_start:Date = new Date(period.start),
                date_end:Date = new Date(period.end);
          switch (this.metricsPivot) {
            case 'yearly':
              return date_end.getFullYear().toString();
            case 'one_year':
              return ('0'+(date_start.getMonth()+1)).slice(-2) + '/' + date_start.getFullYear().toString().slice(-2) + ' — ' +
                     ('0'+(date_end.getMonth()+1)).slice(-2) + '/' + date_end.getFullYear().toString().slice(-2);
            case 'three_years':
              return date_start.getFullYear().toString() + ' — ' + date_end.getFullYear().toString();
          }
        }
      );
    } else {
      return [];
    }
  }

  getPeriodValues(portfolio: string, metric: string, slice?: boolean, pivot?: string): number[] {
    if (slice==undefined) {slice = true;}
    if (pivot==undefined) {pivot = this.metricsPivot;}
    if (portfolio=='investable') {
      if (this.investableMA) {
        if (slice) {
          return this.investableMA[pivot][metric].slice(-this.maxNbColumns[pivot]);
        } else {
          return this.investableMA[pivot][metric];
        }
      } else {
        return [];
      }
    }
  }

  getFormattedPeriodValues(portfolio: string, metric: string, slice?: boolean, pivot?: string) {
    if (slice==undefined) {slice = true;}
    if (pivot==undefined) {pivot = this.metricsPivot;}
    let periods = this.getFormattedPeriods(slice),
        values = this.getPeriodValues(portfolio, metric, slice);

    let periodValues = {};
    periods.forEach(
      (period,index) => {
        periodValues[period] = values[index];
      }
    );

    return periodValues;
  }

}
